const AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content');

window.MessageTemplate = {
    init() {
        this.initDropZone();
        this.initSummerNote();
        this.handleShowCreateModal();
        this.handleCreateModalButtonClicks();
        this.handleMessageTemplateModalButtonClicks();
    },

    initDropZone() {
        const submitButton = document.getElementById('create-message-template-btn');
        const self = this

        const showPreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').removeClass('d-none');
            $(file.previewElement).find('.dz-remove').addClass('d-none'); // avoid removing mid-upload
        };

        const hidePreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').addClass('d-none');
            $(file.previewElement).find('.dz-remove').removeClass('d-none');
        };

        $("#add-message-template-attachment-btn").not(".dz-clickable").each((index, element) => {
            $(element).dropzone({
                url: "/message_templates/upload_message_attachment",
                previewsContainer: document.querySelector('.drop-zone-preview.message-template'),
                previewTemplate: document.querySelector('.drop-zone-custom.message-template').innerHTML,
                uploadMultiple: false,
                maxFiles: 10,
                maxFileSize: 10,
                acceptedFiles: ".jpg,.jpeg,.gif,.png,.tiff,.bmp,.webp,.txt,.csv,.pdf,.xls,.xlsx,.xlsm,.doc,.docx",
                init: function () {
                    this.on("error", function (file) {
                        hidePreviewLoader(file);
                        this.removeFile(file);
                        $('#message-template-attachments').after(
                            '<div class="alert alert-danger alert-dismissable" id="rr-success-alert">' +
                            '<button type="button" class="close" ' +
                            'data-dismiss="alert" aria-hidden="true">' +
                            '&times;' +
                            '</button>' +
                            'An error has occurred uploading file' +
                            '</div>'
                        );
                        submitButton.disabled = false;
                    });

                    this.on("complete", function (file) {
                        hidePreviewLoader(file);
                    });
                },
                params: {
                    'authenticity_token': $('meta[name="csrf-token"]').attr('content')
                },
                timeout: 60000,
                success: (file, response) => {
                    if (response.err_msg == '' || response.err_msg == undefined) {
                        const messageTemplateAttachmentsElement = $("#message-template-attachments");
                        $(file.previewElement).find('.remove-attachment').attr('data-attachment-id', response.id);
                        messageTemplateAttachmentsElement.append(`<input type='hidden' value='${response.id}' name='message_template[message_attachment_ids][]'>`);
                        self.handleOnClickRemoveAttachment();
                    } else {
                        alert(response.err_msg);
                        file.previewElement.remove();
                    }
                    submitButton.disabled = false;
                },
                sending: (file) => {
                    showPreviewLoader(file);
                    submitButton.disabled = true;
                }
            });
        });

        $("#rr-success-alert").fadeTo(5000, 500).slideUp(500, function () {
            $("#rr-success-alert").slideUp(500);
        });
        setTimeout(function () {
            $("#rr-success-alert").remove();
        }, 6000);
    },

    handleRemoveAttachment(e) {
        const attachmentId = e.target.dataset.attachmentId;
        $(`#message-template-attachments :input[value="${attachmentId}"]`).remove();
        $(e.target).parents('.drop-zone-preview.message-template').remove();
    },

    handleOnClickRemoveAttachment() {
        $(".remove-attachment").on('click', this.handleRemoveAttachment.bind(this));
    },

    initSummerNote() {
        const $editor = $('#message_template_message_text');
        $editor.summernote({
            minHeight: 200,
            focus: false,
            airMode: false,
            fontNames: ['Montserrat'],
            fontNamesIgnoreCheck: ['Montserrat'],
            fontSizeUnits: ['pt'],
            dialogsInBody: true,
            dialogsFade: true,
            disableDragAndDrop: false,
            placeholder: '',
            toolbar: [
                ['style', ['bold', 'clear']],
                ['para', ['ul', 'ol']],
                ['misc', ['undo', 'redo']],
                ['insert', ['link']],
                ['customButtons', ['supplierName', 'dealName', 'buyerName']]
            ],
            buttons: {
                supplierName: function () {
                    var ui = $.summernote.ui;
                    var button = ui.button({
                        contents: '{{supplier}}',
                        tooltip: 'Add supplier team name substitution to message text',
                        click: function () {
                            $editor.summernote('focus');
                            $editor.summernote('insertText', '{{supplier}}');
                        }
                    });
                    return button.render();
                },
                dealName: function () {
                    var ui = $.summernote.ui;
                    var button = ui.button({
                        contents: '{{deal}}',
                        tooltip: 'Add deal name substitution to message text',
                        click: function () {
                            $editor.summernote('focus');
                            $editor.summernote('insertText', '{{deal}}');
                        }
                    });
                    return button.render();
                },
                buyerName: function () {
                    var ui = $.summernote.ui;
                    var button = ui.button({
                        contents: '{{buyer}}',
                        tooltip: 'Add buyer team name substitution to message text',
                        click: function () {
                            $editor.summernote('focus');
                            $editor.summernote('insertText', '{{buyer}}');
                        }
                    });
                    return button.render();
                }
            }
        })
            .on('summernote.change', function (customEvent, contents) {
                console.log(contents);
                document.getElementById('hidden_message_text').value = contents.replace(/&nbsp;/g, ' ');
            });
    },

    handleShowCreateModal() {
        const createMessageTemplateModal = $('#create-message-templates-modal');
        createMessageTemplateModal.on('show.bs.modal', function () {
            createMessageTemplateModal.find('#message_template_message_text').summernote('code', '');
            createMessageTemplateModal.find('#hidden_message_text').val('');
            createMessageTemplateModal.find('#message_template_name').val('');
            createMessageTemplateModal.find('#message-template-attachments').empty();
        });
    },

    handleCreateModalButtonClicks() {
        const modalName = 'create-message-templates-modal'
        const modal = $(`#${modalName}`);

        modal.find('#create-message-template-btn').click(() => {
            const templateName = modal.find('#message_template_name').val();
            const templateText = modal.find('#hidden_message_text').val();
            const attachmentIds = Array.from(
                document.querySelectorAll('#create-message-template-form input[name="message_template[message_attachment_ids][]"]')
            ).map(elm => elm.value);

            $.ajax({
                url: `/message_templates/`,
                type: 'POST',
                dataType: 'json',
                data: {
                    name: templateName,
                    message_text: templateText,
                    message_attachment_ids: attachmentIds,
                },
                success: function (data) {
                    modal.modal('hide');
                    if (data && data.html) {
                        const templatesModal = $(`#message-templates-modal`);
                        templatesModal.find('#message-template-list').prepend(data.html);
                    }
                },
                error: function (xhr) {
                    console.error('Failed to save template', xhr.responseText);
                }
            });
        });
    },

    handleMessageTemplateModalButtonClicks() {
        const modalName = 'message-templates-modal'
        const modal = $(`#${modalName}`);
        // Event delegation: works for existing + newly inserted notes
        modal.on('click', '.js-delete-template', function () {
            const templateId = $(this).data('message-template-id');

            $.ajax({
                url: `/message_templates/${templateId}`,
                type: 'DELETE',
                success: function () {
                    modal.find('#message-template-' + templateId).remove();
                },
                error: function () {
                    console.error('Failed to delete template:', templateId);
                }
            });
        });
    }
};
